import { useEffect } from 'react';
import { useApiContext, useGetFullInfo } from 'react-easyrocket';
import { smarticoSetUserData } from 'src/utils/smartico';

export const useSetSmarticoUser = () => {
  const { isAuthenticated } = useApiContext();
  const { fullInfo, isSuccess: getFullInfoSuccess } = useGetFullInfo();

  useEffect(() => {
    if (isAuthenticated && fullInfo?.id) {
      smarticoSetUserData(fullInfo.id, fullInfo.language);
    }
  }, [isAuthenticated, getFullInfoSuccess]);
};
